module.exports = __webpack_public_path__ + "img/logoAndTitleNew.6f63839e.png";